<common-top-tool-bar [title]="'练习批量导入'" [back]="backUrl" [actionsTemplate]="actions">
  <ng-template #actions>
    <button nz-button nzGhost [nzType]="'primary'" [nzSize]="'large'" class="mr-4" (click)="cancel()">
      取消
    </button>
    <button nz-button [nzType]="'primary'" [nzSize]="'large'" [nzLoading]="submitting" [disabled]="!canSubmit" (click)="submit()">
      提交导入
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-main">
  <div class="batch-import-panel">
    <div class="step-block">
      <div class="step-title">1. 下载模板</div>
      <div class="step-desc">模板下载链接稍后可替换成外链，当前先提供同字段的本地 Excel 模板。</div>
      <button nz-button (click)="downloadTemplate()">下载模板</button>
    </div>

    <div class="step-block">
      <div class="step-title">2. 上传 Excel</div>
      <div class="step-desc">仅解析第一个 sheet，从第 3 行开始视为导入数据，单次最多 900 行。</div>
      <div class="upload-row">
        <input nz-input class="upload-name" [ngModel]="uploadFileName" disabled placeholder="请选择 .xls 或 .xlsx 文件" />
        <nz-upload
          nzAction="/user/temp-resource"
          [nzAccept]="'.xls,.xlsx'"
          [nzShowUploadList]="false"
          [nzBeforeUpload]="beforeUpload">
          <button nz-button nzType="primary" [nzLoading]="parsing">选择文件</button>
        </nz-upload>
      </div>
    </div>

    <div class="summary-row" *ngIf="totalRows > 0">
      <div class="summary-card">
        <div class="summary-label">总行数</div>
        <div class="summary-value">{{ totalRows }}</div>
      </div>
      <div class="summary-card success">
        <div class="summary-label">可导入</div>
        <div class="summary-value">{{ validRows.length }}</div>
      </div>
      <div class="summary-card danger">
        <div class="summary-label">本地校验失败</div>
        <div class="summary-value">{{ invalidRows.length }}</div>
      </div>
    </div>

    <nz-alert
      *ngIf="invalidRows.length > 0"
      nzType="error"
      nzShowIcon
      nzMessage="存在本地校验失败的行，修正后才可提交"
      [nzDescription]="localErrorTpl">
    </nz-alert>
    <ng-template #localErrorTpl>
      <div class="error-list">
        <div *ngFor="let row of invalidRows">第 {{ row.rowNo }} 行：{{ row.reason }}</div>
      </div>
    </ng-template>

    <div class="preview-wrap" *ngIf="totalRows > 0">
      <nz-table #previewTable [nzData]="parsedRows" [nzFrontPagination]="false" [nzScroll]="{ x: '1300px', y: '420px' }">
        <thead>
        <tr>
          <th width="90">Excel行号</th>
          <th width="100">题包id</th>
          <th width="260">题干</th>
          <th width="280">选项</th>
          <th width="90">答案</th>
          <th width="160">状态</th>
          <th width="320">原因</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of previewTable.data">
          <td>{{ row.rowNo }}</td>
          <td>{{ row.exerciseIdRaw }}</td>
          <td>{{ row.question }}</td>
          <td>{{ optionsText(row) }}</td>
          <td>{{ row.answerRaw }}</td>
          <td>
            <nz-tag [nzColor]="row.status === 'valid' ? 'success' : 'error'">
              {{ row.status === 'valid' ? '可导入' : '校验失败' }}
            </nz-tag>
          </td>
          <td>{{ row.reason || '-' }}</td>
        </tr>
        </tbody>
      </nz-table>
    </div>

    <div class="result-wrap" *ngIf="submitResult">
      <div class="step-title">3. 导入结果</div>
      <div class="summary-row">
        <div class="summary-card success">
          <div class="summary-label">成功条数</div>
          <div class="summary-value">{{ submitResult.successCount }}</div>
        </div>
        <div class="summary-card danger">
          <div class="summary-label">失败条数</div>
          <div class="summary-value">{{ submitResult.failureCount }}</div>
        </div>
      </div>

      <nz-table *ngIf="submitResult.failures.length > 0" #failureTable [nzData]="submitResult.failures" [nzFrontPagination]="false">
        <thead>
        <tr>
          <th width="120">失败行号</th>
          <th>失败原因</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of failureTable.data">
          <td>{{ item.rowNo }}</td>
          <td>{{ item.reason }}</td>
        </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
